import React from "react";
import withMotion from "../../../../Utils/withMotion";
import Sidebar from "../../Sidebar/Sidebar";
import "../../Blog.scss";
import { Link } from "react-router-dom";

//Utils
import { mapBlogs } from "../../Pagination/utils";

//Images
import banner from "../../images/removingOilStains/blog-oil-stain-banner.jpg";
import img001 from "../../images/removingOilStains/blog-oil-stain-001.jpg";
import img002 from "../../images/removingOilStains/blog-oil-stain-002.jpg";
import img003 from "../../images/removingOilStains/blog-oil-stain-003.jpg";
import img004 from "../../images/removingOilStains/blog-oil-stain-004.jpg";

// SEO
import SEO from "../../../../SEO/index.js";
import StructuredData from "../../../../SEO/structuredData";
import { ViewPavers } from "../../../../CTA/CTA";

export const RemovingOilStainsData = {
  title:
    "Removing Stains on Pavers: From Oil and Grease to Hard Water and Rust",
  image: banner,
  destination: "/blog/removing-stains-pavers-oil-grease-hard-water-rust",
  date: "August 18, 2016",
  categories: ["blog", "installation", "paving-stones"],
};

const RemovingOilStains = () => {
  const blog = [RemovingOilStainsData];

  return (
    <>
      <SEO
        title="How to Remove Stains From Pavers - Oil, Grease, Rust & Hard Water"
        description="Removing stains on pavers is possible in most circumstances if you follow these helpful tips. Learn how to remove stain from oil, grease, hard water, and rust."
        profileURL={
          "https://www.pacificpavingstone.com/blog/removing-stains-pavers-oil-grease-hard-water-rust"
        }
      />
      <StructuredData
        orgaCreator={{
          "@context": "https://schema.org/",
          "@type": "BlogPosting",
          author: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
          URL: " https://www.pacificpavingstone.com/blog/removing-stains-pavers-oil-grease-hard-water-rust",
          headline:
            "How to Remove Stains From Pavers - Oil, Grease, Rust & Hard Water ",
          description:
            "Removing stains on pavers is possible in most circumstances if you follow these helpful tips. Learn how to remove stain from oil, grease, hard water, and rust. ",
          image: {
            "@type": "ImageObject",
            url: "https://www.pacificpavingstone.com/static/media/blog-oil-stain-banner.04ee54dd.jpg",
          },
          datePublished: "2016-08-18",
          publisher: {
            "@type": "Organization",
            name: "Pacific Pavingstone",
          },
        }}
      />
      <div className="container-fluid page-blog">
        <div className="row justify-content-center">
          <div className="col-11 col-lg-6">
            {mapBlogs(1, blog, true)}
            <p>
              Paving stone driveways are a popular choice for not only their
              classy appearance, but also the reduced maintenance they provide
              compared to asphalt or concrete.
              <br />
              <br />
              Even if you choose to have a landscaping company or paving
              contractor install pavers, there could come a point when your
              driveway may experienced unwanted stains. Removing stains on
              pavers is possible in most circumstances if you follow these
              helpful tips.
            </p>
            <h4 className="text-blue">How to Remove Stains on Pavers</h4>
            <img src={img001} alt="Feature" />
            <p>
              Manufactured concrete pavers are similar to many other driveway,
              patio, or walkway materials in one respect. Their surface is
              porous and can easily absorb stains. Even if protective measures
              are taken and sealants are applied to their surface, paver stains
              and typical dirt deposits can happen even with the best care.
              <br />
              <br />
              Paving stones can be removed and replaced as a last resort, making
              them far superior over asphalt or concrete. However, before
              replacement is considered, try removing stains on pavers with
              these general guidelines and specific strategies.
            </p>
            <h4 className="text-blue">
              General Guidelines for Removing Stains on Pavers
            </h4>
            <img src={img002} alt="Feature" />
            <p>
              We’ll get to specific remedies for removing stains on pavers in a
              moment, but here are some general guidelines to follow.
            </p>
            <ul>
              <li>
                Manufacturers have the best guidelines for specific stains. Ask
                your contractor if their are any resources they can direct you
                to on how to remove stains on pavers.
              </li>
              <li>
                Before you try any specific method, try to find the most
                inconspicuous area of your driveway to test the cleaning agent’s
                end result. Always read the instructions on cleaning materials.
                Follow the instructions exactly for mixing, application,
                personal protective gear, and first aid in the event of an
                accident.
              </li>
              <li>
                Thoroughly rinse areas after applying materials to paver stains.
                Try to wash materials away from plants if possible. If this is
                not possible, try to dilute the solution with as much water as
                possible.
              </li>
              <li>
                If you’re trying to remove oil stains on pavers, use a granular
                absorbing material (resembles kitty litter). Much of the spill
                can be absorbed this way versus rubbing it into the paver.
                Rubbing could make the problem worse.
              </li>
              <li>
                Use soft, nylon bristled brushes that won’t scratch pavers. If a
                pressure washer is used at some point, understand that this can
                dislodge the polymeric sand in paver joints that enables them to
                interlock. Some new sand could need to be added when the surface
                thoroughly dries.
              </li>
            </ul>
            <h4 className="text-blue">
              Specific Recommendations for Removing Stains on Pavers
            </h4>
            <img src={img003} alt="Feature" />
            <p>
              Paver manufacturers may slightly vary with recommendations
              depending upon the stain and specific product used for your
              driveway, walkway, or patio. However, these are some common,
              specific tips for removing stains on pavers.{" "}
            </p>
            <h4 className="text-blue">Removing Oil Stains on Pavers</h4>
            <p>
              Oils of many sources may stain pavers. The most common source can
              be oil dripping from a vehicle parked on a paving stone driveway.
              However, oil and grease deposits can be commonly found on paver
              patios near a grill or outdoor kitchen.
            </p>
            <ol>
              <li>
                Keep some paper towels, rags, and a bucket of granular
                oil-absorbent material handy in garages or outdoor kitchens.
              </li>
              <li>
                If oil or grease is freshly deposited, lightly blot (not rub)
                the areas with a clean rag or paper towels. Liquid dish soap or
                laundry detergent will remove most oil stains on pavers.
                Directly apply the soap to the stain and allow to sit for 20-30
                minutes. Then scrub with a nylon bristle brush and rinse with
                hot water. Repeat this step as needed.
              </li>
              <li>
                {" "}
                If removing oil stains on pavers after the material has dried
                and absorbed, soak up as much oil on pavers as possible. Leave
                granular materials on areas for approximately 6 hours. Sweep up
                the material. Follow the instructions above for freshly
                deposited stains.
              </li>
            </ol>
            <h4 className="text-blue">
              Removing Hard Water Stains on Pavers A.K.A Efflorescence
            </h4>
            <p>
              Most of what people refer to as water stains on pavers is actually
              a natural process called efflorescence. Pavers begin to exhibit a
              powder-like deposit, most commonly in the first couple years after
              installation.
              <br />
              <br />
              Efflorescence is caused when the soluble salt salts in the pavers
              react with rainfall, humidity and temperatures fluctuating. As the
              water evaporates, the salts come to the surface, creating a
              whitish appearance.
              <br />
              <br />
              If you wish to speed up nature’s cleaning process, most paver
              manufacturers offer an Efflorescence Remover. This cleaner can be
              somewhat abrasive, so be sure to test an inconspicuous area first,
              and then clean the entire paver surface.
            </p>
            <h4 className="text-blue">Removing Rust Stains on Pavers</h4>
            <p>
              If steel or iron items sit on or above paver areas for a period of
              time, you may end up with rust stains on pavers. As rusting metal
              drips onto these areas, particularly over a long period of time,
              removing rust stains on pavers becomes very difficult.
              <br />
              <br />
              Removing rust stains on pavers requires a material that can damage
              sealers that may have been previously applied. This material may
              also cause some surface etching on pavers so you may want to apply
              the material to the entire paver area surface for uniform look.
              Test a small area first and consult with a paving stone contractor
              if needed.
              <br /> <br />
              If possible, remove rusting metals from these areas. However, if
              cleaning is needed, paver manufacturers often offer rust remover
              materials. Apply the material according its label’s directions.
              Scrub the area with a soft, nylon bristle brush and rinse
              thoroughly.
            </p>
            <h4 className="text-blue">Successful Stain Removal on Pavers</h4>
            <img src={img004} alt="Feature" />
            <p>
              The best defense against stains on pavers is regular inspection.
              The longer a contaminant sits on a paving stone, the greater the
              potential for staining. Make it part of your routine to inspect
              these areas weekly.
              <br />
              <br />
              Clean the areas thoroughly a few times a year, before typical dirt
              can settle in. Talk to a reputable paving stone installer to
              discuss any options for adding sealants to these areas for added
              protection against stains on pavers.
              <br />
              <br />
              Remember that one of the best features of pavers over other
              surface materials is that if you can still remove a stained
              section and replace them with new paving stones. This is less
              conspicuous the newer your surface is.
            </p>
            <p>
              <Link to="/contact-us">
                If you’d like to discuss replacing any of these stained areas or
                how to maintain them, please contact us.
              </Link>
            </p>
            <ViewPavers/>
          </div>
          <Sidebar />
        </div>
      </div>
    </>
  );
};

export default withMotion(RemovingOilStains);
